import { ENTITY_TYPE } from 'common/constants';
import { MenuItemDef } from './dashboard/nav';
import {
  AssessmentOutlined,
  BadgeOutlined,
  BeachAccess,
  Brush,
  CasesOutlined,
  CompareArrows,
  Dashboard,
  FormatColorFill,
  FreeCancellation,
  GroupOutlined,
  Groups2Outlined,
  Home,
  ListAlt,
  MenuBookOutlined,
  Payments,
  RecentActorsOutlined,
  RequestPage,
  RequestPageOutlined,
  RequestQuoteOutlined,
  Schedule,
  SchoolOutlined,
  Title,
  Today,
  ViewTimelineOutlined,
  WorkOffOutlined,
  WorkOutlined,
  ArticleOutlined,
  AssignmentAdd,
  ReceiptLong,
  AccountBalanceWallet,
  LinkOff,
  SmartToyOutlined,
  CardMembershipOutlined,
  GridOn,
  StarOutlined,
  AccountTreeOutlined,
} from '@mui/icons-material';

export const navData: MenuItemDef[] = [
  {
    labelKey: 'mainNavigation.home',
    path: '/',
    icon: <Home />,
  },
  {
    labelKey: 'mainNavigation.clients',
    path: '/clients',
    icon: <GroupOutlined />,
    identifier: 'ui.nav.clients',
  },
  {
    labelKey: 'mainNavigation.providers',
    path: '/providers',
    icon: <RecentActorsOutlined />,
    identifier: 'ui.nav.providers',
  },
  {
    labelKey: 'mainNavigation.projects',
    path: '/projects',
    icon: <CasesOutlined />,
    identifier: 'ui.nav.projects',
  },
  {
    labelKey: 'mainNavigation.timesheet',
    path: '/timesheet',
    icon: <ViewTimelineOutlined />,
    identifier: 'ui.nav.timesheet',
  },
  {
    labelKey: 'mainNavigation.mySkills',
    path: '/my-skills',
    icon: <StarOutlined />,
    identifier: 'ui.nav.my-skills',
    entityType: ENTITY_TYPE.EMPLOYEE,
  },
  {
    labelKey: 'mainNavigation.myTeam',
    path: '/myteam',
    icon: <Groups2Outlined />,
    requiresSupervisor: true,
  },
  // Reports Menu with children
  {
    labelKey: 'mainNavigation.reports',
    path: '/reports',
    icon: <AssessmentOutlined />,
    entityType: ENTITY_TYPE.ANY,
    identifier: 'ui.nav.reports',
    children: [
      {
        labelKey: 'mainNavigation.timesheet',
        path: '/reports/timesheet',
        icon: <Schedule />,
        entityType: ENTITY_TYPE.EMPLOYEE,
        identifier: 'ui.nav.reports.my-timesheet',
      },
      {
        labelKey: 'mainNavigation.timesheet',
        path: '/reports/timesheet/client',
        icon: <Schedule />,
        entityType: ENTITY_TYPE.CLIENT,
        identifier: 'ui.nav.reports.my-timesheet',
      },
      {
        labelKey: 'mainNavigation.billing',
        path: '/reports/billing',
        icon: <Payments />,
        entityType: ENTITY_TYPE.EMPLOYEE,
        identifier: 'ui.nav.reports.billing',
      },
      {
        labelKey: 'mainNavigation.billing',
        path: '/reports/billing/client',
        icon: <RequestPage />,
        entityType: ENTITY_TYPE.CLIENT,
        identifier: 'ui.nav.reports.billing',
      },
      {
        labelKey: 'mainNavigation.utilization',
        path: '/reports/utilization',
        icon: <AssignmentAdd />,
        entityType: ENTITY_TYPE.ANY,
        identifier: 'ui.nav.reports.utilization',
      },
      {
        labelKey: 'mainNavigation.allocationVsTimesheet',
        path: '/reports/allocation-vs-timesheet',
        icon: <CompareArrows />,
        entityType: ENTITY_TYPE.ANY,
        identifier: 'ui.nav.reports.allocation-vs-timesheet',
      },
    ],
  },
  // Human Resources Menu with children
  {
    labelKey: 'mainNavigation.humanResources',
    path: '/humanresources',
    icon: <Groups2Outlined />,
    identifier: 'ui.nav.hr',
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.employees',
        path: '/employees',
        icon: <BadgeOutlined />,
        identifier: 'ui.nav.employees',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.regime',
        path: '/regime',
        icon: <Today />,
        identifier: 'ui.nav.hr.regime',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.myPTO',
        path: '/timeOff',
        icon: <WorkOffOutlined />,
        identifier: 'ui.nav.hr.my-pto',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.manage.PTO',
        path: '/timeOffHR',
        icon: <FreeCancellation />,
        identifier: 'ui.nav.hr.manage-pto',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.holidays',
        path: '/Calendar/Holidays',
        icon: <BeachAccess />,
        identifier: 'ui.nav.hr.holidays',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.training',
        path: '/hr/training',
        icon: <SchoolOutlined />,
        identifier: 'ui.nav.hr.training',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.trainingCourses',
        path: '/hr/training-courses',
        icon: <MenuBookOutlined />,
        identifier: 'ui.nav.hr.training-courses',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.trainingCertifications',
        path: '/hr/training-certifications',
        icon: <CardMembershipOutlined />,
        identifier: 'ui.nav.hr.training-certifications',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.profiles',
        path: '/hr/profiles',
        icon: <BadgeOutlined />,
        identifier: 'ui.nav.hr.profiles',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.cvConfiguration',
        path: '/hr/cv-configuration',
        icon: <ArticleOutlined />,
        identifier: 'ui.nav.hr.cv-configuration',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.jobOpenings',
        path: '/hr/job-openings',
        icon: <WorkOutlined />,
        identifier: 'ui.nav.hr.job-openings',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.skillMatrix',
        path: '/hr/skill-matrix',
        icon: <GridOn />,
        identifier: 'ui.nav.hr.skill-matrix',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.humanResources.orgChart',
        path: '/hr/org-chart',
        icon: <AccountTreeOutlined />,
        identifier: 'ui.nav.hr.org-chart',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
    ],
  },
  // Invoices Menu with children
  {
    labelKey: 'mainNavigation.invoiceOrBilling',
    path: '/invoices-menu',
    icon: <RequestPageOutlined />,
    identifier: 'ui.nav.invoices',
    entityType: ENTITY_TYPE.ANY,
    children: [
      {
        labelKey: 'mainNavigation.invoice.myInvoices',
        path: '/myInvoices',
        icon: <RequestQuoteOutlined />,
        identifier: 'ui.nav.invoices.my-invoices',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.invoice.myInvoices',
        path: '/myInvoices',
        icon: <RequestQuoteOutlined />,
        identifier: 'ui.nav.invoices.my-invoices',
        entityType: ENTITY_TYPE.PROVIDER,
      },
      {
        labelKey: 'mainNavigation.billing.accountsPayable',
        path: '/accountspayable',
        icon: <Payments />,
        identifier: 'ui.nav.invoices.accounts-payable',
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
      {
        labelKey: 'mainNavigation.billing.invoicing',
        path: '/invoicing',
        icon: <RequestPage />,
        identifier: 'ui.nav.invoices.invoicing',
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
      {
        labelKey: 'mainNavigation.billing.invoicing',
        path: '/invoicing',
        icon: <RequestPage />,
        identifier: 'ui.nav.invoices.invoicing',
        entityType: ENTITY_TYPE.CLIENT,
      },
      {
        labelKey: 'mainNavigation.billing.newInvoice',
        path: '/newinvoice',
        icon: <AssignmentAdd />,
        identifier: 'ui.nav.invoices.new-invoice',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
      {
        labelKey: 'mainNavigation.billing.upload',
        path: '/uploadinvoice',
        icon: <RequestQuoteOutlined />,
        identifier: 'ui.nav.invoices.upload',
        entityType: ENTITY_TYPE.EMPLOYEE,
      },
    ],
  },

  // Finance Menu
  {
    labelKey: 'mainNavigation.finance',
    path: '/finance',
    icon: <AccountBalanceWallet />,
    identifier: 'ui.nav.finance',
    entityType: ENTITY_TYPE.CORPORATE_ENTITY,
    children: [
      {
        labelKey: 'mainNavigation.finance.accounts',
        path: '/accounts',
        icon: <ReceiptLong />,
        identifier: 'ui.nav.finance.accounts',
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },{
        labelKey: 'mainNavigation.finance.unreconciledAp',
        path: '/reports/unreconciled-ap',
        icon: <LinkOff />,
        identifier: 'ui.nav.finance.unreconciled-ap',
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },{
        labelKey: 'mainNavigation.finance.unreconciledAr',
        path: '/reports/unreconciled-invoices',
        icon: <LinkOff />,
        identifier: 'ui.nav.finance.unreconciled-ar',
        entityType: ENTITY_TYPE.CORPORATE_ENTITY,
      },
    ],
  },

  // Showcase Menu with children
  /*{
    labelKey: 'Showcase',
    icon: <Brush />,
    children: [
      {
        labelKey: 'Components',
        path: '/showcase/components',
        icon: <Dashboard />,
      },
      {
        labelKey: 'Colors',
        path: '/showcase/colors',
        icon: <FormatColorFill />,
      },
      {
        labelKey: 'Typography',
        path: '/showcase/typography',
        icon: <Title />,
      },
      {
        labelKey: 'DataGrid',
        path: '/showcase/datagrid',
        icon: <ListAlt />,
      },
    ],
  },*/
  {
    labelKey: 'mainNavigation.aiCredits',
    path: '/ai-credits',
    icon: <SmartToyOutlined />,
    identifier: 'ui.nav.ai-credits',
  },
];
